import { useContext } from 'react';

// eslint-disable-next-line import/order
import type { BFFConsumerEnum } from '../../constants';
import { BFFContext } from '../context';

export function useConsumer(): {
	consumer: BFFConsumerEnum | null;
} {
	const {
		value: { consumer },
	} = useContext(BFFContext);

	return {
		consumer,
	};
}
